import api from '@/api/axios';
import { ENDPOINTS } from '@/api/endpoints';
import {
  LoginCredentials,
  LoginResponse,
  SignUpData,
  ForgotPasswordData,
  ResetPasswordData,
  User,
} from '@/types';

/**
 * Authentication API service
 * Replaces Angular's AuthService HTTP methods
 */

/**
 * Login user
 */
export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>(ENDPOINTS.AUTH.LOGIN, credentials);
  return response.data;
};

/**
 * Sign up new user
 */
export const signUp = async (data: SignUpData): Promise<User> => {
  const response = await api.post<User>(ENDPOINTS.AUTH.SIGNUP, data);
  return response.data;
};

/**
 * Request password reset
 */
export const forgotPassword = async (data: ForgotPasswordData): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>(ENDPOINTS.AUTH.FORGOT_PASSWORD, data);
  return response.data;
};

/**
 * Reset password with token
 */
export const resetPassword = async (data: ResetPasswordData): Promise<{ message: string }> => {
  const response = await api.post<{ message: string }>(ENDPOINTS.AUTH.RESET_PASSWORD, data);
  return response.data;
};

export const authApi = {
  login,
  signUp,
  forgotPassword,
  resetPassword,
};

export default authApi;
